import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner
} from '../../config/react'
import DataTable from 'react-data-table-component'

const ProductAttribute = () => {
  const [ListData, setListData] = useState([])
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  const columns = [
    {
      name: 'Attribute Name',

      sortable: true,
      sortField: 'attribute_name',

      selector: (row) => row.attribute_name,
      wrap: true
    },
    {
      name: 'Attribute Code',
      selector: (row) => row.attribute_code,
      wrap: true
    },
    // {
    //   name: 'Default Label',
    //   wrap: true,
    //   selector: (row) => row.attribute_name
    // },
    {
      name: 'Visible In Filters',
      selector: (row) => (row.show_in_storefront === 1 ? 'Yes' : 'No')
    },
    {
      name: 'Visible In Product Page',
      selector: (row) => (row.show_in_detail_page === 1 ? 'Yes' : 'No')
    },
    // {
    //   name: 'Default Value',
    //   selector: (row) => row.default_value
    // },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? 'Active' : 'Inactive')
    },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      wrap: true,
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/attribute/productattribute/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => {
              if (row.is_product_exist || row.is_used_by_system) {
                e.preventDefault()
              } else {
                DeleteProductAttribute(e, row.id)
              }
            }}
            to=""
            className={
              row.is_product_exist || row.is_used_by_system ? 'text-dark disabled' : 'text-dark'
            }
            title={row.is_product_exist ? Messages.ProductAttributeDeleteError : 'Delete'}
            disabled={row.is_product_exist}
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  const GetProductAttributeList = () => {
    const listparam = {
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    // console.log('Listing page '+CustomFilters.page+' &page_size '+CustomFilters.page_size);
    setLoading(true)
    HttpService.postApi(API.GetProductAttributeAdminList, listparam).then((response) => {
      setLoading(false)
      // console.log(response);
      // setSizeList(response.data.result[0])

      if (response.data.status === true) {
        const data = response.data.result[1]
        setListData(data)
        settotalRows(response.data.result[0][0].total_row)
        setForceUpdate(!isForceUpdate)
      }
    })
  }

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.ProductAttribute
    GetProductAttributeList()
  }, [CustomFilters])

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
    // GetProductAttributeList();
  }
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Attribute Code, Default Label."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setCustomFilters({ ...CustomFilters, page: currentPage, search: e.target.value })
        }
      />
    )
  })

  const DeleteProductAttribute = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          IsDeleted: true,
          Userid: user.id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteProductAttribute, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetProductAttributeList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }
  const handleSort = (e, direction) => {
    // console.log('LN 146 Sort FIeld ' + e.sortField)
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.ProductAttribute} </h3>
        <div className="btn-group">
          <Link
            to="/attribute/productattribute/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            {Title.AddProductAttribute}{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={ListData}
                  persistTableHead={true}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductAttribute
